export default __webpack_public_path__ + "static/media/V680MANC3.c730a93a.pdf";